import {
  Component, Vue,
} from 'vue-property-decorator';

import style from './index.module.scss';

@Component({
  name: 'ChannelRightsCard',
})
export default class ChannelRightsCard extends Vue {
  /** 渠道权益卡权益说明 */
  private render() {
    return (
      <div class={style.rightsItems}>
        <div class={style.rightsItem}>
          <span class={[style.rightsValue, style.firstValue]}>吃喝玩乐</span>
          权益 尽情享
        </div>
        <div class={style.rightsItem}>
          热门会员权益
          <span class={style.rightsValue}>随心选</span>
        </div>
        <div class={style.rightsItem}>
          更多
          <span class={style.rightsValue}>丰富权益</span>
          可见详情
        </div>
      </div>
    );
  }
}
